import React, { useState } from 'react';
import { Kicker, CharReveal } from './ui';
import { Odometer } from './Odometer';
type Mode = 'project' | 'monthly';
const TIERS = [{
  name: 'Sprint',
  tagline: 'For a defined brief with a hard deadline.',
  price: {
    project: '4,800',
    monthly: '3,200'
  },
  unit: {
    project: 'from, per project',
    monthly: 'per month'
  },
  features: ['One focused deliverable', '2 to 4 week timeline', 'Two revision rounds', 'Full source files on handover'],
  featured: false
}, {
  name: 'Partner',
  tagline: 'For teams that need a studio on call.',
  price: {
    project: '12,000',
    monthly: '6,500'
  },
  unit: {
    project: 'from, per engagement',
    monthly: 'per month'
  },
  features: ['Brand, web and motion combined', 'Weekly demos and async standups', 'Priority turnaround', 'Quarterly strategy reviews'],
  featured: true
}];
export function Pricing() {
  const [mode, setMode] = useState<Mode>('project');
  return <section id="pricing" className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32" data-id="element-123">
      <div className="flex flex-wrap items-end justify-between gap-8" data-id="element-124">
        <div data-id="element-125">
          <Kicker ig="Ọ́nụ Ahịa" en="Investment" data-id="element-126" />
          <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-127">
            <CharReveal text="Pricing" data-id="element-128" />
          </h2>
        </div>
        <div className="flex rounded-full border p-1" style={{
        borderColor: 'var(--line)'
      }} role="group" aria-label="Billing mode" data-id="element-129">
          {(['project', 'monthly'] as Mode[]).map(m => <button key={m} onClick={() => setMode(m)} className="font-monoui text-[11px] md:text-xs uppercase tracking-[0.16em] rounded-full px-5 md:px-7 py-2.5 transition-colors" style={mode === m ? {
          background: 'var(--danfo)',
          color: 'var(--ink)'
        } : {
          color: 'var(--paper-dim)'
        }} data-id="element-130">
              {m === 'project' ? 'Per project' : 'Monthly'}
            </button>)}
        </div>
      </div>

      <div className="mt-12 md:mt-16 grid gap-6 md:grid-cols-2" data-id="element-131">
        {TIERS.map(t => <div key={t.name} className="relative rounded-2xl border p-8 md:p-12" style={{
        background: 'var(--ink-2)',
        borderColor: t.featured ? 'var(--danfo)' : 'var(--line)'
      }} data-id="element-132">
            {t.featured && <span className="font-monoui absolute -top-3 left-8 text-[10px] uppercase tracking-[0.16em] px-3 py-1" style={{
          background: 'var(--danfo)',
          color: 'var(--ink)'
        }} data-id="element-133">
                Most booked
              </span>}
            <h3 className="font-display uppercase text-3xl md:text-4xl tracking-tight" data-id="element-134">{t.name}</h3>
            <p className="mt-2 text-sm md:text-base" style={{
          color: 'var(--paper-dim)'
        }} data-id="element-135">
              {t.tagline}
            </p>
            <p className="font-display mt-8 text-5xl md:text-7xl" data-id="element-136">
              $<Odometer key={`${t.name}-${mode}`} value={t.price[mode]} delayStep={70} duration={1.2} data-id="element-137" />
            </p>
            <p className="font-monoui text-[11px] uppercase tracking-[0.16em] opacity-50 mt-3" data-id="element-138">{t.unit[mode]}</p>
            <ul className="mt-8 space-y-3.5" data-id="element-139">
              {t.features.map(f => <li key={f} className="flex items-start gap-3 text-sm md:text-base" data-id="element-140">
                  <span style={{
              color: 'var(--danfo)'
            }} aria-hidden="true" data-id="element-141">✦</span>
                  <span style={{
              color: 'var(--paper-dim)'
            }} data-id="element-142">{f}</span>
                </li>)}
            </ul>
            <a href="#contact" className="font-monoui mt-10 inline-block text-xs uppercase tracking-[0.18em] px-7 py-4 transition-transform hover:-translate-y-0.5" style={t.featured ? {
          background: 'var(--danfo)',
          color: 'var(--ink)'
        } : {
          border: '1px solid var(--line)'
        }} data-id="element-143">
              Book a call
            </a>
          </div>)}
      </div>

      <p className="mt-8 font-monoui text-[11px] md:text-xs uppercase tracking-[0.16em] opacity-40" data-id="element-144">
        Every engagement starts with a 30 minute call. No decks, no pressure.
      </p>
    </section>;
}